<div class="ovulation_indeuction header_top mb-5">
  <section class="ovulation_induction_banner">
    <div class="container">
      <div class="banner_content">
        <h6>Intrauterine Insemination<br />in Kannur</h6>
        <h5>A Simple & Effective Fertility Solution</h5>
        <h2 class="visually-hidden">
          Intrauterine Insemination (IUI) Treatment in Kannur
        </h2>
        <p>
          Struggling to conceive naturally? Intrauterine Insemination (IUI) is a
          safe and minimally invasive fertility treatment that increases the
          chances of pregnancy by placing healthy sperm directly into the uterus
          during ovulation.
        </p>
        <button (click)="contactus()">Book a Consultation</button>
      </div>
    </div>
  </section>
  <section class="how_does_work_ivf mt-5">
    <div class="container">
      <div class="row aic">
        <div class="col-lg-7 col-md-7 col-sm-12">
          <h6>Who Can Benefit from IUI?</h6>
          <p>
            If you and your partner have been trying to conceive without
            success, IUI may be the right fertility solution for you. This
            treatment is particularly beneficial for couples facing mild
            fertility challenges and looking for a less invasive alternative to
            IVF.
          </p>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12">
          <img
            loading="lazy"
            src="../../../../assets/images/treatment/intrauterine_insemination/who_can_benefit_from_ovarian_induction.webp"
            alt=""
          />
        </div>
      </div>
    </div>
  </section>
  <section class="iui_is_recommended mt-5">
    <h4 class="title_header tac">IUI is recommended for</h4>
    <div class="container">
      <div class="section">
        <img
          loading="lazy"
          src="../../../../assets/images/treatment/intrauterine_insemination/iui_recommended_1.webp"
          alt="Mild Male Factor Infertility"
        />
        <div class="text">
          <h3>Mild Male Factor Infertility</h3>
          <p>
            If your partner has low sperm count or poor sperm motility, IUI can
            help by placing high-quality sperm directly into the uterus,
            increasing the chances of fertilization.
          </p>
        </div>
      </div>

      <div class="section">
        <img
          loading="lazy"
          src="../../../../assets/images/treatment/intrauterine_insemination/iui_recommended_2.webp"
          alt="Unexplained Infertility"
        />
        <div class="text">
          <h3>Unexplained Infertility</h3>
          <p>
            When standard fertility tests show no identifiable issues, IUI is
            often the first line of treatment before considering advanced
            procedures like IVF.
          </p>
        </div>
      </div>

      <div class="section">
        <img
          loading="lazy"
          src="../../../../assets/images/treatment/intrauterine_insemination/iui_recommended_3.webp"
          alt="Cervical Mucus Issues"
        />
        <div class="text">
          <h3>Cervical Mucus Issues</h3>
          <p>
            In some cases, thick cervical mucus can prevent sperm from reaching
            the egg. IUI bypasses this problem by directly depositing sperm into
            the uterus, improving the likelihood of conception.
          </p>
        </div>
      </div>

      <div class="section">
        <img
          loading="lazy"
          src="../../../../assets/images/treatment/intrauterine_insemination/iui_recommended_4.webp"
          alt="Irregular Ovulation or PCOS"
        />
        <div class="text">
          <h3>Irregular Ovulation or PCOS</h3>
          <p>
            If you have irregular menstrual cycles or ovulatory disorders like
            Polycystic Ovary Syndrome (PCOS), IUI combined with
            ovulation-inducing medication can significantly improve your chances
            of getting pregnant.
          </p>
        </div>
      </div>

      <div class="section">
        <img
          loading="lazy"
          src="../../../../assets/images/treatment/intrauterine_insemination/iui_recommended_5.webp"
          alt="Affordable & Less Invasive Option"
        />
        <div class="text">
          <h3>Affordable & Less Invasive Option</h3>
          <p>
            Compared to IVF, IUI is a quicker, more affordable, and minimally
            invasive option, making it a popular first-step fertility treatment
            for many couples.
          </p>
        </div>
      </div>
    </div>
  </section>
  <section class="pink_bg_content mt-5">
    <div class="container">
      <div class="pink_bg_content_child">
        <!-- <h5>CTA BANNER CONTENT </h5> -->
        <p>
          Still unsure if IUI is right for you? Our fertility specialists at
          NCare IVF Kannur, Kerala provide comprehensive <br />
          assessments to determine the best treatment based on your reproductive
          health.
        </p>
        <button (click)="contactus()">Book a Consultation Today</button>
      </div>
    </div>
  </section>
  <section class="how_does_ivf_process_work mt-5">
    <div class="title_header tac">IUI Treatment Process</div>
    <p class="title_para">
      We follow a streamlined and patient-friendly approach to maximize your
      chances of conception.
    </p>
    <div class="container">
      <div class="row">
        <div class="col-lg-5 col-md-5 col-sm-12 ls" data-step="1">
          <img
            loading="lazy"
            src="../../../../assets/images/treatment/iui/iuits_1.webp"
            alt=""
          />
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12">
          <h5>Step 1: Ovulation Support</h5>
          <p>Medications may be used to enhance egg development if needed.</p>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12 ls" data-step="2">
          <h5>Step 2: Fertility Evaluation</h5>
          <p>
            A detailed assessment, including blood tests, ultrasound, and semen
            analysis.
          </p>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12">
          <img
            loading="lazy"
            src="../../../../assets/images/treatment/iui/iuits_2.webp"
            alt=""
          />
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12 ls" data-step="3">
          <img
            loading="lazy"
            src="../../../../assets/images/treatment/iui/iuits_3.webp"
            alt=""
          />
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12">
          <h5>Step 3: Sperm Preparation</h5>
          <p>The healthiest sperm are selected for insemination.</p>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12 ls" data-step="4">
          <h5>Step 4: Quick & Painless IUI</h5>
          <h5></h5>
          <p>
            Sperm is gently placed into the uterus at the right time for
            fertilization.
          </p>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12">
          <img
            loading="lazy"
            src="../../../../assets/images/treatment/iui/iuits_4.webp"
            alt=""
          />
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12 ls" data-step="5">
          <img
            loading="lazy"
            src="../../../../assets/images/treatment/iui/iuits_5.webp"
            alt=""
          />
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12">
          <h5>Step 5: Pregnancy Test</h5>
          <p>A follow up test after two weeks to check for success.</p>
        </div>
      </div>
    </div>
  </section>

  <section class="ivf_success_rate mt-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-5 cool-md-5 col-sm-12">
          <h6>
            <span>Understanding IUI</span> <br />
            Success Rates
          </h6>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-12">
          <p>
            The success of IUI depends on various factors, including the woman’s
            age, ovulation health, sperm quality, and overall reproductive
            conditions. Women under 35 typically have a 10-20% success rate per
            cycle, while those over 35 may experience a 5-10% success rate.
            Combining IUI with ovulation induction medications can further
            enhance the chances of pregnancy. Many couples conceive within 3-6
            cycles, making IUI a practical first step before considering
            advanced treatments like IVF. At NCare IVF, we provide personalized
            fertility care, ensuring the best approach to maximize your chances
            of conception.
          </p>
        </div>
      </div>
    </div>
  </section>
  <section class="what_we_provide mt-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <img
            loading="lazy"
            src="../../assets/images/treatment/what_we_provide.webp"
            alt=""
          />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <h6>Key Benefits of IUI</h6>
          <ul>
            <li>Painless & non-invasive</li>
            <li>Higher fertilization chances</li>
            <li>Affordable fertility solution</li>
            <li>Quick & effective process</li>
            <li>Expert fertility care</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section class="why_choose_ncare_ivf_kannur mt-5">
    <div class="container">
      <h1 class="title_header tac">IUI Success Factors</h1>
      <p class="title_para">
        The success of IUI depends on multiple factors, including age,
        reproductive health, and sperm quality. Women under 35 have higher
        success rates per cycle, while those over 35 may require multiple
        attempts. Lifestyle choices, such as maintaining a healthy diet,
        managing stress, and avoiding harmful habits, can further improve the
        chances of conception. Proper medical guidance and advanced sperm
        preparation techniques also enhance the overall effectiveness of the
        treatment.
      </p>
      <h1 class="title_header tac">Key Factors Enhancing IUI Success</h1>

      <div class="row">
        <span></span>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../../assets/images/treatment/iui/iuisf_1.svg"
              alt=""
            />
            <h5>Non-Invasive & Affordable</h5>
            <p>
              Women under 35 experience a higher success rate per cycle, while
              tailored approaches support those over 35.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../../assets/images/treatment/iui/iuisf_2.svg"
              alt=""
            />
            <h5>Ovulation & Hormonal Balance</h5>
            <p>
              Personalized ovulation support maximizes the chances of successful
              fertilization.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../../assets/images/treatment/iui/iuisf_3.svg"
              alt=""
            />
            <h5>Advanced Sperm Selection</h5>
            <p>
              Cutting-edge techniques ensure only the healthiest sperm are used,
              enhancing conception potential.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../../assets/images/treatment/iui/iuisf_4.svg"
              alt=""
            />
            <h5>Healthy Lifestyle Impact</h5>
            <p>
              Proper nutrition, regular exercise, and stress management
              contribute to improved fertility outcomes.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../../assets/images/treatment/iui/iuisf_5.svg"
              alt=""
            />
            <h5>Effective Treatment Cycles</h5>
            <p>
              Many couples achieve pregnancy within a few well-planned IUI
              cycles, making it a trusted fertility solution.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="faq mt-5">
    <h4 class="title_header tac">Frequently Asked Questions</h4>
    <div class="container">
      <div class="accordion" id="accordionExample">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              Is IUI a painful procedure?
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse collapse show"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              No, IUI is a quick and painless procedure. Some women may
              experience mild cramping, but there is no need for anesthesia or
              recovery time.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              How long does the IUI process take?
            </button>
          </h2>
          <div
            id="collapseTwo"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              An IUI cycle, including ovulation stimulation and insemination,
              typically lasts 10-14 days. The actual insemination takes only a
              few minutes.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              How many IUI cycles should I try before considering IVF?
            </button>
          </h2>
          <div
            id="collapseThree"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Doctors generally recommend 3-6 IUI cycles before exploring
              advanced treatments like IVF, depending on individual fertility
              conditions.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
            >
              What should I do after the IUI procedure?
            </button>
          </h2>
          <div
            id="collapseFour"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Resting for a short period is recommended, but you can resume
              normal activities the same day. A pregnancy test is scheduled
              after two weeks to check for success.
            </div>
          </div>
        </div>
      </div>
      <button class="contact_us_info" (click)="contactus()">
        Contact Us for more information
      </button>
    </div>
  </section>
</div>
<div class="ovulation_indeuction header_top mb-5">
  <section class="ovulation_induction_banner">
    <div class="container">
      <div class="banner_content">
        <h6>Intrauterine Insemination<br />in Kannur</h6>
        <h5>A Simple & Effective Fertility Solution</h5>
        <h2 class="visually-hidden">
          Intrauterine Insemination (IUI) Treatment in Kannur
        </h2>
        <p>
          Struggling to conceive naturally? Intrauterine Insemination (IUI) is a
          safe and minimally invasive fertility treatment that increases the
          chances of pregnancy by placing healthy sperm directly into the uterus
          during ovulation.
        </p>
        <button (click)="contactus()">Book a Consultation</button>
      </div>
    </div>
  </section>
  <section class="how_does_work_ivf mt-5">
    <div class="container">
      <div class="row aic">
        <div class="col-lg-7 col-md-7 col-sm-12">
          <h6>Who Can Benefit from IUI?</h6>
          <p>
            If you and your partner have been trying to conceive without
            success, IUI may be the right fertility solution for you. This
            treatment is particularly beneficial for couples facing mild
            fertility challenges and looking for a less invasive alternative to
            IVF.
          </p>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12">
          <img
            loading="lazy"
            src="../../../../assets/images/treatment/intrauterine_insemination/who_can_benefit_from_ovarian_induction.webp"
            alt=""
          />
        </div>
      </div>
    </div>
  </section>
  <section class="iui_is_recommended mt-5">
    <h4 class="title_header tac">IUI is recommended for</h4>
    <div class="container">
      <div class="section">
        <img
          loading="lazy"
          src="../../../../assets/images/treatment/intrauterine_insemination/iui_recommended_1.webp"
          alt="Mild Male Factor Infertility"
        />
        <div class="text">
          <h3>Mild Male Factor Infertility</h3>
          <p>
            If your partner has low sperm count or poor sperm motility, IUI can
            help by placing high-quality sperm directly into the uterus,
            increasing the chances of fertilization.
          </p>
        </div>
      </div>

      <div class="section">
        <img
          loading="lazy"
          src="../../../../assets/images/treatment/intrauterine_insemination/iui_recommended_2.webp"
          alt="Unexplained Infertility"
        />
        <div class="text">
          <h3>Unexplained Infertility</h3>
          <p>
            When standard fertility tests show no identifiable issues, IUI is
            often the first line of treatment before considering advanced
            procedures like IVF.
          </p>
        </div>
      </div>

      <div class="section">
        <img
          loading="lazy"
          src="../../../../assets/images/treatment/intrauterine_insemination/iui_recommended_3.webp"
          alt="Cervical Mucus Issues"
        />
        <div class="text">
          <h3>Cervical Mucus Issues</h3>
          <p>
            In some cases, thick cervical mucus can prevent sperm from reaching
            the egg. IUI bypasses this problem by directly depositing sperm into
            the uterus, improving the likelihood of conception.
          </p>
        </div>
      </div>

      <div class="section">
        <img
          loading="lazy"
          src="../../../../assets/images/treatment/intrauterine_insemination/iui_recommended_4.webp"
          alt="Irregular Ovulation or PCOS"
        />
        <div class="text">
          <h3>Irregular Ovulation or PCOS</h3>
          <p>
            If you have irregular menstrual cycles or ovulatory disorders like
            Polycystic Ovary Syndrome (PCOS), IUI combined with
            ovulation-inducing medication can significantly improve your chances
            of getting pregnant.
          </p>
        </div>
      </div>

      <div class="section">
        <img
          loading="lazy"
          src="../../../../assets/images/treatment/intrauterine_insemination/iui_recommended_5.webp"
          alt="Affordable & Less Invasive Option"
        />
        <div class="text">
          <h3>Affordable & Less Invasive Option</h3>
          <p>
            Compared to IVF, IUI is a quicker, more affordable, and minimally
            invasive option, making it a popular first-step fertility treatment
            for many couples.
          </p>
        </div>
      </div>
    </div>
  </section>
  <section class="pink_bg_content mt-5">
    <div class="container">
      <div class="pink_bg_content_child">
        <!-- <h5>CTA BANNER CONTENT </h5> -->
        <p>
          Still unsure if IUI is right for you? Our fertility specialists at
          NCare IVF Kannur, Kerala provide comprehensive <br />
          assessments to determine the best treatment based on your reproductive
          health.
        </p>
        <button (click)="contactus()">Book a Consultation Today</button>
      </div>
    </div>
  </section>
  <section class="how_does_ivf_process_work mt-5">
    <div class="title_header tac">IUI Treatment Process</div>
    <p class="title_para">
      We follow a streamlined and patient-friendly approach to maximize your
      chances of conception.
    </p>
    <div class="container">
      <div class="row">
        <div class="col-lg-5 col-md-5 col-sm-12 ls" data-step="1">
          <img
            loading="lazy"
            src="../../../../assets/images/treatment/iui/iuits_1.webp"
            alt=""
          />
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12">
          <h5>Step 1: Ovulation Support</h5>
          <p>Medications may be used to enhance egg development if needed.</p>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12 ls" data-step="2">
          <h5>Step 2: Fertility Evaluation</h5>
          <p>
            A detailed assessment, including blood tests, ultrasound, and semen
            analysis.
          </p>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12">
          <img
            loading="lazy"
            src="../../../../assets/images/treatment/iui/iuits_2.webp"
            alt=""
          />
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12 ls" data-step="3">
          <img
            loading="lazy"
            src="../../../../assets/images/treatment/iui/iuits_3.webp"
            alt=""
          />
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12">
          <h5>Step 3: Sperm Preparation</h5>
          <p>The healthiest sperm are selected for insemination.</p>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12 ls" data-step="4">
          <h5>Step 4: Quick & Painless IUI</h5>
          <h5></h5>
          <p>
            Sperm is gently placed into the uterus at the right time for
            fertilization.
          </p>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12">
          <img
            loading="lazy"
            src="../../../../assets/images/treatment/iui/iuits_4.webp"
            alt=""
          />
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12 ls" data-step="5">
          <img
            loading="lazy"
            src="../../../../assets/images/treatment/iui/iuits_5.webp"
            alt=""
          />
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12">
          <h5>Step 5: Pregnancy Test</h5>
          <p>A follow up test after two weeks to check for success.</p>
        </div>
      </div>
    </div>
  </section>

  <section class="ivf_success_rate mt-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-5 cool-md-5 col-sm-12">
          <h6>
            <span>Understanding IUI</span> <br />
            Success Rates
          </h6>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-12">
          <p>
            The success of IUI depends on various factors, including the woman’s
            age, ovulation health, sperm quality, and overall reproductive
            conditions. Women under 35 typically have a 10-20% success rate per
            cycle, while those over 35 may experience a 5-10% success rate.
            Combining IUI with ovulation induction medications can further
            enhance the chances of pregnancy. Many couples conceive within 3-6
            cycles, making IUI a practical first step before considering
            advanced treatments like IVF. At NCare IVF, we provide personalized
            fertility care, ensuring the best approach to maximize your chances
            of conception.
          </p>
        </div>
      </div>
    </div>
  </section>
  <section class="what_we_provide mt-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <img
            loading="lazy"
            src="../../assets/images/treatment/what_we_provide.webp"
            alt=""
          />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <h6>Key Benefits of IUI</h6>
          <ul>
            <li>Painless & non-invasive</li>
            <li>Higher fertilization chances</li>
            <li>Affordable fertility solution</li>
            <li>Quick & effective process</li>
            <li>Expert fertility care</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section class="why_choose_ncare_ivf_kannur mt-5">
    <div class="container">
      <h1 class="title_header tac">IUI Success Factors</h1>
      <p class="title_para">
        The success of IUI depends on multiple factors, including age,
        reproductive health, and sperm quality. Women under 35 have higher
        success rates per cycle, while those over 35 may require multiple
        attempts. Lifestyle choices, such as maintaining a healthy diet,
        managing stress, and avoiding harmful habits, can further improve the
        chances of conception. Proper medical guidance and advanced sperm
        preparation techniques also enhance the overall effectiveness of the
        treatment.
      </p>
      <h1 class="title_header tac">Key Factors Enhancing IUI Success</h1>

      <div class="row">
        <span></span>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../../assets/images/treatment/iui/iuisf_1.svg"
              alt=""
            />
            <h5>Non-Invasive & Affordable</h5>
            <p>
              Women under 35 experience a higher success rate per cycle, while
              tailored approaches support those over 35.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../../assets/images/treatment/iui/iuisf_2.svg"
              alt=""
            />
            <h5>Ovulation & Hormonal Balance</h5>
            <p>
              Personalized ovulation support maximizes the chances of successful
              fertilization.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../../assets/images/treatment/iui/iuisf_3.svg"
              alt=""
            />
            <h5>Advanced Sperm Selection</h5>
            <p>
              Cutting-edge techniques ensure only the healthiest sperm are used,
              enhancing conception potential.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../../assets/images/treatment/iui/iuisf_4.svg"
              alt=""
            />
            <h5>Healthy Lifestyle Impact</h5>
            <p>
              Proper nutrition, regular exercise, and stress management
              contribute to improved fertility outcomes.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../../assets/images/treatment/iui/iuisf_5.svg"
              alt=""
            />
            <h5>Effective Treatment Cycles</h5>
            <p>
              Many couples achieve pregnancy within a few well-planned IUI
              cycles, making it a trusted fertility solution.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="faq mt-5">
    <h4 class="title_header tac">Frequently Asked Questions</h4>
    <div class="container">
      <div class="accordion" id="accordionExample">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              Is IUI a painful procedure?
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse collapse show"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              No, IUI is a quick and painless procedure. Some women may
              experience mild cramping, but there is no need for anesthesia or
              recovery time.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              How long does the IUI process take?
            </button>
          </h2>
          <div
            id="collapseTwo"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              An IUI cycle, including ovulation stimulation and insemination,
              typically lasts 10-14 days. The actual insemination takes only a
              few minutes.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              How many IUI cycles should I try before considering IVF?
            </button>
          </h2>
          <div
            id="collapseThree"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Doctors generally recommend 3-6 IUI cycles before exploring
              advanced treatments like IVF, depending on individual fertility
              conditions.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
            >
              What should I do after the IUI procedure?
            </button>
          </h2>
          <div
            id="collapseFour"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Resting for a short period is recommended, but you can resume
              normal activities the same day. A pregnancy test is scheduled
              after two weeks to check for success.
            </div>
          </div>
        </div>
      </div>
      <button class="contact_us_info" (click)="contactus()">
        Contact Us for more information
      </button>
    </div>
  </section>
</div>
